"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

/* injects from baggage-loader */

var NODE_MAX_WIDTH = exports.NODE_MAX_WIDTH = 300;
var NODE_BORDER_RADIUS = exports.NODE_BORDER_RADIUS = 16;
var NODE_PADDING_VERTICAL = exports.NODE_PADDING_VERTICAL = 8;
var NODE_PADDING_HORIZONTAL = exports.NODE_PADDING_HORIZONTAL = 12;


//////////////////
// WEBPACK FOOTER
// ./app/components/Projects/StaticProjectView/constants.js
// module id = 223
// module chunks = 1